import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=c5875918&"
import script from "./ChatWidget.vue?vue&type=script&lang=js&"
export * from "./ChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports